/* eslint-disable @nx/enforce-module-boundaries */
import { cloud, teamwork, trophy } from '@prishapolicy/w3/assets';
import Image from 'next/image';

export const ExplainPosp = () => {
  return (
    <div className="container flex flex-col gap-10 py-[60px]">
      <div className="grid grid-cols-1 items-center gap-y-10 xl:grid-cols-2 xl:gap-0">
        <div className="flex flex-col gap-3">
          <div className="bg-primary h-[5px] w-[50px] rounded-lg"></div>
          <h1 className="text-title-4 font-bold leading-[60px] md:text-[40px] lg:text-[40px]">What is POSP?</h1>
          <p className="text-body-3 md:text-title-6 lg:text-title-6 font-medium">
            A Point of Sales Person or POS is a self employed sales superstar responsible for selling various financial
            products without breaking a sweat. They act as a bridge between the customer and the companies they
            represent offering the best solution that caters to the client needs.
          </p>
        </div>
        <div className="mb-[10px]">
          <div className="flex justify-center">
            <div className="relative ">
              <Image src={cloud} width={536} height={329} alt="cloud" />
            </div>
            <div className="absolute mt-[-20px] px-[93px]">
              <Image src={teamwork} width={350} height={350} alt="cloud" />
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 items-center gap-y-10 xl:grid-cols-2 xl:gap-0">
        <div className="order-2 col-span-1 xl:order-1">
          <div className="flex justify-center">
            <div className="relative ">
              <Image src={cloud} width={536} height={329} alt="cloud" />
            </div>
            <div className="absolute mt-[-20px] px-[93px]">
              <Image src={trophy} width={350} height={350} alt="cloud" />
            </div>
          </div>
        </div>
        <div className="order-1 col-span-1 flex flex-col gap-3 xl:order-2 ">
          <div className="flex justify-start lg:justify-end">
            <div className="bg-primary h-[5px] w-[50px] rounded-lg "></div>
          </div>
          <h1 className="text-title-4 text-left font-bold leading-[60px] md:text-[40px] lg:text-right lg:text-[40px]">
            Why become a POSP?
          </h1>
          <p className="text-body-1 md:text-title-6 lg:text-title-6 text-left font-medium lg:text-right">
            Why wait? Embrace the POSP way of life and embark on a journey to financial independence. Take that plush
            throne as your own boss and earn money with every product sold.
          </p>
        </div>
      </div>
    </div>
  );
};
